import { create } from 'zustand';
export const useGaslessPreferenceStore = create()((set) => ({
    gaslessEnabled: true,
    gaslessUnavailable: false,
    gaslessFailureStage: null,
    gaslessErrorMessage: null,
    setGaslessEnabled: (value) => set({ gaslessEnabled: value, gaslessUnavailable: false, gaslessFailureStage: null, gaslessErrorMessage: null }),
    reportGaslessUnavailable: (stage, message) => set({ gaslessUnavailable: true, gaslessFailureStage: stage, gaslessErrorMessage: message ?? null }),
    switchToStandardTransfer: () => set({ gaslessEnabled: false, gaslessUnavailable: false, gaslessFailureStage: null, gaslessErrorMessage: null }),
    clearGaslessUnavailable: () => set({ gaslessUnavailable: false, gaslessFailureStage: null, gaslessErrorMessage: null }),
    resetGaslessPreference: () => set({ gaslessEnabled: true, gaslessUnavailable: false, gaslessFailureStage: null, gaslessErrorMessage: null }),
}));
